export const localization = {
  pt: {
    title: 'Gerencie o host do certificado {0}',
    host: 'Host',
    actions: 'Ações',
  },
  en: {
    title: 'Manage the host of the certificate {0}',
    host: 'Host',
    actions: 'Actions',
  },
  es: {
    title: 'Administrar el host del certificado {0}',
    host: 'Host',
    actions: 'Acciones',
  },
};
